import { LegalShell } from '@/pages/legal/LegalShell';

export default function Privacidad() {
  return (
    <LegalShell title="Privacidad y protección de datos" updated="2026" testId="privacy-page">
      <p>Esta política explica qué datos tratamos y cómo los protegemos en la versión actual de la plataforma.</p>
      <h2>1. Datos que tratamos</h2>
      <ul>
        <li>Datos de cuenta: nombre, correo, teléfono y preferencias de entrega.</li>
        <li>Datos de pedidos: artículos, destinatario, dirección y estado de preparación/entrega.</li>
        <li>Datos de identidad y de negocio para registros de vendedor, incluidos documentos privados (PDF/JPG/PNG, máx. 10 MB).</li>
        <li>Ubicación aproximada que tú proporcionas para calcular disponibilidad y cobertura de entrega.</li>
      </ul>
      <h2>2. Cómo protegemos la información</h2>
      <ul>
        <li>Las contraseñas se almacenan cifradas (hash bcrypt); nunca en texto plano.</li>
        <li>Los documentos privados de identidad y finanzas se guardan en la base de datos con acceso restringido por autorización y con registro de quién los sube y consulta.</li>
        <li>No exponemos URLs públicas ni descargas directas de esos documentos.</li>
      </ul>
      <h2>3. Uso de la ubicación</h2>
      <p>La ubicación se usa exclusivamente para mostrar ofertas con stock y cobertura y para ordenar por distancia geodésica. No calculamos rutas ni rastreamos tu desplazamiento en tiempo real.</p>
      <h2>4. Conservación</h2>
      <p>Conservamos los datos mientras tu cuenta esté activa y según las obligaciones operativas y legales aplicables. La política definitiva de retención y de baja de cuenta se publicará al cerrarse los requisitos legales.</p>
      <h2>5. No venta de datos</h2>
      <p>No vendemos tus datos personales. No hay integraciones de correo, SMS o mensajería activas en esta versión.</p>
      <h2>6. Tus solicitudes</h2>
      <p>Para consultar, corregir o solicitar la eliminación de tus datos, escríbenos desde <a className="underline" href="/contacto">Contacto</a>.</p>
    </LegalShell>
  );
}
